import { motion } from "framer-motion";
import { Quote, Image as ImageIcon } from "lucide-react";

const PLACEHOLDERS = [0, 1, 2];

export default function TestimonialsSection() {
  return (
    <section className="bg-[#F7FAFC] py-20 text-shipany-navy sm:py-24" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }} className="text-center">
          <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#0757D9]">Testimonials</span>
          <h2 className="font-display mt-3 text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">Loved by Shipping Teams Across India</h2>
          <p className="mx-auto mt-3 max-w-lg text-sm text-slate-500">Real customer stories will appear here as launch partners share their results.</p>
        </motion.div>
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {PLACEHOLDERS.map((i) => (
            <motion.figure key={i} initial={{ opacity: 0, y: 26 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: i * 0.1, duration: 0.5 }} whileHover={{ y: -5 }}
              className="flex flex-col rounded-2xl border border-dashed border-slate-300 bg-white p-6" data-testid={`testimonial-placeholder-${i + 1}`}>
              <Quote className="h-6 w-6 text-slate-300" />
              <blockquote className="mt-3 flex-1 text-sm italic leading-relaxed text-slate-400">
                Customer testimonial placeholder — a real ShipAny partner story will be published here.
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-slate-100 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-300">
                  <ImageIcon className="h-4 w-4" />
                </span>
                <div>
                  <p className="text-sm font-bold text-slate-400">Partner Brand</p>
                  <p className="text-xs text-slate-400">Founder / Ops Head · Volume: —</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
